"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

function deleteForward(editorState, start, end) {
  return editorState.change({
    isBoundary: editorState.lastChangeType !== constants_1.COMMAND.DELETE_FORWARD,
    type: constants_1.COMMAND.DELETE_FORWARD,
    start: start,
    end: end,
    value: []
  }).change({
    type: constants_1.COMMAND.DELETE_FORWARD,
    start: end + 1,
    end: end + 1,
    value: []
  });
}

exports.default = deleteForward;